import {Pipe, PipeTransform} from "@angular/core";
import {ProcessType} from "../../store/state/order.state";

@Pipe({
    name: 'processTypeDisplay',
    standalone: false
})
export class ProcessTypeDisplayPipe implements PipeTransform {

	transform(value: ProcessType): string {
		switch (value) {
			case ProcessType.INITIAL_CERTIFICATION:
				return 'initial';
			case ProcessType.RECERTIFICATION:
				return 'renewal';
			case ProcessType.TRANSFER:
				return 'transfer';
		}

		return null;
	}
}
